import axios from 'axios';
import type { OnboardingPortalAssociation } from '@bb/automaton';

const getOnboardingPortalAssociationByPortalId = async ({
  portalId,
  orgId,
}: {
  portalId: string;
  orgId: string;
}) => {
  const url = `/onboarding-portal/${portalId}/onboarding-portal-association`;

  const { data } = await axios.get<OnboardingPortalAssociation | undefined>(
    url,
    { params: { orgId } },
  );

  return data;
};

export default getOnboardingPortalAssociationByPortalId;
